import React, { useState, useEffect, useRef } from "react";
import assets from "../assets/imgs";

function CalendarPopup({ selectedDate, onSelect, onClose, limitUnit = 'day', anchorRef }) {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [ mode, setMode ] = useState(limitUnit);
  const popupRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [isReady, setIsReady] = useState(false);


  // 위치 계산
  useEffect(() => {
    if (anchorRef?.current && popupRef.current) {
      const rect = anchorRef.current.getBoundingClientRect();
      const popupHeight = popupRef.current.offsetHeight;
      const popupWidth = popupRef.current.offsetWidth;

      const offset = 10;

      let top = rect.bottom + offset;
      let left = rect.left;

      // 화면이 밑으로 벗어나면 위로 위치 조정
      if (top + popupHeight > window.innerHeight) {
        //화면이 밑으로도 벗어나고 위로도 벗어나면 적당히 우측으로 밀어서 가운데로
        if( rect.top - popupHeight - offset < 0){
          top = rect.top - popupHeight / 2;
          left = rect.left + 100;
          if(rect.left + popupWidth > window.innerWidth){
            left = rect.left - popupWidth / 2;
          }
        }else{
          top = rect.top - popupHeight - offset;
        }
      }
      

      setPosition({ top, left });
      setIsReady(true);

    }
  }, [anchorRef]);

  //초기 날짜 설정
  useEffect(() => {
    if (selectedDate) {
      setCurrentDate(new Date(selectedDate));
    }
  }, [selectedDate]);

  //월 변경
  const handleMonthChange = (offset) => {
    setCurrentDate((prev) => {
      const newDate = new Date(prev);
      newDate.setMonth(prev.getMonth() + offset);
      return newDate;
    });
  };
  
  //년도 변경
  const handleYearChange = (offset) =>{
    setCurrentDate((prev) => {
      const newDate = new Date(prev);
      newDate.setFullYear(prev.getFullYear() + offset);
      return newDate;
    });
  };

  // 날짜 선택
  const handleDateClick = (day) => {
    const newSelectedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), day); // ✅ 정확한 날짜 설정
    const formattedDate = `${newSelectedDate.getFullYear()}-${String(newSelectedDate.getMonth() + 1).padStart(2, "0")}-${String(newSelectedDate.getDate()).padStart(2, "0")}`;
    onSelect(formattedDate);
    setTimeout(() => onClose(), 50);
  };

  //월 선택
  const handleMonthSelect = (month) => {
    if (limitUnit === "month") {
      const newSelectedDate = new Date(currentDate.getFullYear(), month, 1);
      const formattedDate = `${newSelectedDate.getFullYear()}-${String(newSelectedDate.getMonth() + 1).padStart(2, "0")}-01`;
      onSelect(formattedDate);
      // onSelect(newSelectedDate.toISOString().split("T")[0]); // YYYY-MM-DD 형식 반환
      
      setTimeout(() => onClose(), 50);
      // onClose();
    } else {
      setCurrentDate((prev) => new Date(prev.getFullYear(), month, 1));
      setMode("day");
    }
  };

  //년 선택
  const handleYearSelect = (year) => {
    if (limitUnit === "year") {
      onSelect(`${year}-01-01`); // YYYY-MM-DD 형식 반환
      
      setTimeout(() => onClose(), 50);
      // onClose();
    } else {
      setCurrentDate(new Date(year, currentDate.getMonth(), 1));
      setMode("month");
    }
  };

  // 외부 클릭하면 닫기
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".calendar-popup")) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [onClose]);

  // 📌 현재 월의 첫 날과 마지막 날 계산
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
  const daysInMonth = lastDayOfMonth.getDate();
  const firstDayOfWeek = firstDayOfMonth.getDay();

  // 📌 달력에 표시할 날짜 리스트 생성
  const daysArray = [];
  for (let i = 0; i < firstDayOfWeek; i++) {
    daysArray.push(null); // 빈 칸 채우기
  }
  for (let i = 1; i <= daysInMonth; i++) {
    daysArray.push(i);
  }

  return (
    <div ref={popupRef} className="calendar-popup" style={{
      ...styles.popup,
      top: `${position.top}px`,
      left: `${position.left}px`,
      visibility: isReady ? "visible" : "hidden",
    }}>
      {/* 📌 헤더 (년도/월 선택) */}

      <div style={styles.header}>
        {mode === "day" && (
          <>
            <button onClick={() => handleMonthChange(-1)} style={styles.arrow}><assets.icons.chevron_left/></button>
            <div onClick={() => setMode("month")} style={styles.selectableText}>
              <img src={assets.icons.calendar} style={styles.calendarIcon} alt="캘린더 아이콘" />
              <span className="font-body1-semibold">
                {currentDate.getFullYear()}.{currentDate.getMonth() + 1}
              </span>
            </div>
            <button onClick={() => handleMonthChange(1)} style={styles.arrow}><assets.icons.chevron_right/></button>
          </>
        )}
        {mode === "month" && (
          <>
            <button onClick={() => handleYearChange(-1)} style={styles.arrow}><assets.icons.chevron_left/></button>
            <div onClick={() => setMode("year")} style={styles.selectableText}>
              <img src={assets.icons.calendar} style={styles.calendarIcon} alt="캘린더 아이콘" />
              <span className="font-body1-semibold">
                {currentDate.getFullYear()}
              </span>
            </div>
            <button onClick={() => handleYearChange(1)} style={styles.arrow}><assets.icons.chevron_right/></button>
          </>
        )}
         {mode === "year" && (
          <>
            <button onClick={() => handleYearChange(-10)} style={styles.arrow}><assets.icons.chevron_left/></button>
            <div style={{...styles.selectableText, cursor: "default"}}>
              <img src={assets.icons.calendar} style={styles.calendarIcon} alt="캘린더 아이콘" />
              <span className="font-body1-semibold">
                {Math.floor(currentDate.getFullYear() / 10) * 10}
              </span>
            </div>
            <button onClick={() => handleYearChange(10)} style={styles.arrow}><assets.icons.chevron_right/></button>
          </>
        )}
      </div>

      {/* 📌 년도 선택 모드 */}
      {mode === "year" && (
        <div style={styles.grid}>
          {Array.from({ length: 12 }, (_, i) => currentDate.getFullYear() - 5 + i).map((year) => (
            <div key={year} style={styles.years} onClick={() => handleYearSelect(year)} className="font-body2-semibold">
              {year}년
            </div>
          ))}
        </div>
      )}

      {/* 📌 월 선택 모드 */}
      {mode === "month" && (
        <div style={styles.grid}>
          {Array.from({ length: 12 }, (_, i) => (
            <div key={i} style={styles.yearMonth} onClick={() => handleMonthSelect(i)} className="font-body2-semibold">
              {i + 1}월
            </div>
          ))}
        </div>
      )}

      {/* 📌 일 선택 모드 */}
      {mode === "day" && (
        <>
          <div style={styles.weekdays}>
            {["일", "월", "화", "수", "목", "금", "토"].map((day) => (
              <div key={day} style={styles.weekday} className="font-body3-semibold">{day}</div>
            ))}
          </div>

          <div style={styles.days}>
            {daysArray.map((day, index) => {
              const isSelected = selectedDate && new Date(selectedDate).getDate() === day &&
                new Date(selectedDate).getMonth() === currentDate.getMonth() &&
                new Date(selectedDate).getFullYear() === currentDate.getFullYear();

              return (
                <div
                  key={index}
                  style={day ? 
                    { ...styles.day, 
                      backgroundColor: isSelected ? "#C1104233" : "white", 
                      border: isSelected ? "1px solid var(--primary-crimson_30)" : "0px"} 
                    : styles.emptyDay}
                  onClick={day ? () => handleDateClick(day) : undefined}
                  className="font-body2-semibold"
                >
                  {day}
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
const dayCommon = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  color: "var(--text-color_60)"
};

//  스타일 정의
const styles = {
  popup: {
    position: "fixed",
    // top: `${position.top}px`,
    // left: `${position.left}px`,
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    // padding: "16px",
    zIndex: 1000,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom: "8px",
    padding: "16px",
    height: "60px",
    width: "380px",
    boxSizing : "border-box",
    borderBottom: "1px solid var(--grayscale-cool_20)"
  },
  calendarIcon: {
    width: "20px"
  },
  arrow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    border: "1px solid var(--grayscale-cool_40)",
    borderRadius: "8px",
    width: "28px",
    height: "28px",
    backgroundColor: "white",
  },
  selectableText: {
    display: "flex",
    gap: "12px",
    display:"flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer"
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "12px",
    padding: "8px 20px 20px 20px",
  },
  years:{
    ...dayCommon,
    height: "70px",
  },
  yearMonth: {
    ...dayCommon,
    height: "105px",
  },
  weekdays: {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    fontWeight: "bold",
    padding: "8px 20px 0px 20px",
    color: "var(--text-color_60)"
  },
  weekday:{
    ...dayCommon,
    cursor: "default",
    height: "45px",
  },
  days: {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    padding: "0px 20px 20px 20px"
  },
  day: {
    ...dayCommon,    
    height: "58px",
    borderRadius: "8px",
  },
  emptyDay: {
    visibility: "hidden",
  },
};

export default CalendarPopup;